import Vue from 'vue';
import VueRouter from 'vue-router';

// / Load Components
import components from '@/components';
import refreshToken from '@/middleware/refresh-token';

const { replace } = VueRouter.prototype

const { isNavigationFailure, NavigationFailureType } = VueRouter

VueRouter.prototype.replace = function (location) {
  return replace.call(this, location).catch(error => {
    if (!isNavigationFailure(error, NavigationFailureType.duplicated)) {
      throw Error(error)
    }
  })
}

// Tell vue to use the router
Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'index', component: components['customer-index'], meta: { middleware: refreshToken } },
  {
    path: '/customers',
    name: 'customers',
    component: components['customer-index'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/customers/new',
    name: 'customers_create',
    component: components['customer-create'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/customers/new/migration',
    name: 'customers_migrate',
    component: components['customer-create'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/customers/new/demo',
    name: 'customers_demo',
    component: components['customer-create'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/customers/:customer_id',
    name: 'customers_show',
    component: components['customer-show'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/customers/:customer_id/new_invoice',
    name: 'invoice-form',
    component: components['invoice-form'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/customers/:customer_id/new_payment',
    name: 'payment-form',
    component: components['payment-form'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/customers/:customer_id/impersonate',
    name: 'customers_impersonate',
    component: components['customer-impersonate'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/customers/:customer_id/new_purchase',
    name: 'new-purchase-form',
    component: components['customer-new-purchase-form'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/customers/:customer_id/new_staff_access',
    name: 'customer-staff-access-form',
    component: components['customer-staff-access-form'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/change_logs',
    name: 'change_logs',
    component: components['change-logs-index'],
    meta: { middleware: refreshToken }
  },

  {
    path: '/organizations',
    name: 'organizations',
    component: components['organization-index'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/organizations/new',
    name: 'organizations_create',
    component: components['organization-create'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/organizations/:organization_id',
    name: 'organization_edit',
    component: components['organization-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/customers/:customer_id/edit',
    name: 'customers_edit',
    component: components['customer-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },
  { path: '/plans', name: 'plans', component: components['plans'], meta: { middleware: refreshToken } },
  {
    path: '/plan/:plan_id',
    name: 'edit_plan',
    component: components['plan'],
    props: true,
    meta: { middleware: refreshToken }
  },
  { path: '/plan', name: 'plan', component: components['plan'], meta: { middleware: refreshToken } },

  { path: '/products', name: 'products', component: components['products'], meta: { middleware: refreshToken } },
  {
    path: '/product/:product_id',
    name: 'edit_product',
    component: components['product'],
    props: true,
    meta: { middleware: refreshToken }
  },
  { path: '/product', name: 'product', component: components['product'], meta: { middleware: refreshToken } },

  {
    path: '/payment_terms',
    name: 'payment_terms',
    component: components['payment-terms'],
    meta: { middleware: refreshToken }
  },

  {
    path: '/order_channels',
    name: 'order_channels',
    component: components['order-channel-index'],
    meta: { middleware: refreshToken }
  },

  {
    path: '/carriers',
    name: 'carriers',
    component: components['carrier-index'],
    meta: { middleware: refreshToken }
  },

  {
    path: '/order_channel_types',
    name: 'order_channel_types',
    component: components['order-channel-type-index'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/order_channel_types/new',
    name: 'order_channel_type_create',
    component: components['order-channel-type-create'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/order_channel_types/:order_channel_type_id',
    name: 'order_channel_type',
    component: components['order-channel-type-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },

  { path: '/invoices', name: 'invoices', component: components['invoices'], meta: { middleware: refreshToken } },

  {
    path: '/carrier_types',
    name: 'carrier_types',
    component: components['carrier-type-index'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/carrier_types/new',
    name: 'carrier_type_create',
    component: components['carrier-type-create'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/carrier_types/:carrier_type_id',
    name: 'carrier_type',
    component: components['carrier-type-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/staff_accounts',
    name: 'staffs',
    component: components['staff-index'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/staff_accounts/new',
    name: 'staff_create',
    component: components['staff-create'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/staff_accounts/:staff_id',
    name: 'staff',
    component: components['staff-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/groups',
    name: 'user_groups',
    component: components['user-groups'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/groups/:user_group_id',
    name: 'user_group',
    component: components['user-group-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/sign_in',
    name: 'authentication',
    component: components['authentication'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/barcode_ranges',
    name: 'barcode_ranges',
    component: components['barcode-ranges-index'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/barcode_ranges/new',
    name: 'barcode_range_create',
    component: components['barcode-range-create'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/barcode_ranges/:id',
    name: 'barcode_range',
    component: components['barcode-range-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/applications/',
    name: 'oauth_applications',
    component: components['oauth-applications-index'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/applications/new',
    name: 'oauth_application_create',
    component: components['oauth-application-create'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/applications/:application_id',
    name: 'oauth_application',
    component: components['oauth-application-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/automations/',
    name: 'automations',
    component: components['automations-index'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/automations/new',
    name: 'automation_create',
    component: components['automations-create'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/automations/:automation_id',
    name: 'automation_edit',
    component: components['automations-update'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/error_messages/',
    name: 'error_messages',
    component: components['errors-index'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/zipcodes/',
    name: 'zipcode_formats',
    component: components['zipcodes-index'],
    props: true,
    meta: { middleware: refreshToken }
  },

  {
    path: '/mail_templates/new',
    name: 'mail_template_create',
    component: components['mail-templates-create'],
    meta: { middleware: refreshToken }
  },
  {
    path: '/mail_templates/:mail_template_id',
    name: 'mail_template_edit',
    component: components['mail-templates-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/mail_templates',
    name: 'mail_templates',
    component: components['mail-templates-index'],
    meta: { middleware: refreshToken }
  },

  {
    path: '/mail_builders/:mail_builder_template_type_id',
    name: 'mail_builder_edit',
    component: components['mail-builders-edit'],
    props: true,
    meta: { middleware: refreshToken }
  },
  {
    path: '/mail_builders',
    name: 'mail_builders',
    component: components['mail-builders-index'],
    meta: { middleware: refreshToken }
  },

  {
    path: '/capabilities',
    name: 'capabilities',
    component: components['capabilities-index'],
    meta: { middleware: refreshToken }
  },

  {
    path: '/white_label_reports',
    name: 'white_label_reports',
    component: components['white-label-reports-index'],
    meta: { middleware: refreshToken }
  }
];
// Create new router
const router = new VueRouter({
  routes: routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active'
});

/*
// Info/Guides:
// https://router.vuejs.org/guide/advanced/navigation-guards.html
// https://markus.oberlehner.net/blog/implementing-a-simple-middleware-with-vue-router/
//
// Responsible for creating a new nextMiddleware() callback function, 
// which is basically a wrapper around the default next() callback.
*/

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  
  if (!subsequentMiddleware) {
    return context.next;
  }

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

/*
// We’re looking for a middleware property in the meta object of the route which is currently processed. 
// If the property is found, the Middleware function is executed 
// with the nextMiddleware() callback as its third parameter. 
// That way each Middleware can control if the next Middleware is executed or not
*/

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
